import type { Place } from '@types';
import type React from 'react';

export type DeviceProps = {
  device?: 'kiosk';
};

export type BreadcrumbProps = {
  label: string;
  onClick: () => void;
};

export type BreadcrumbsProps = {
  items: BreadcrumbProps[];
};

export type LocationDetails = {
  id: number;
  name: string;
  description: string;
  image: string;
};

export type SideProps = {
  side?: 'left' | 'right' | 'none';
};

export type PinProps = SideProps & {
  location: Place;
  x: number;
  y: number;
  mapContainerRef: React.RefObject<HTMLDivElement>;
  visible: boolean;
};

export type Coordinates = {
  x: number;
  y: number;
};

export enum MapsLabels {
  MY_LOCATION = 'My Location',
}

export type LatLng = {
  lat: number;
  lng: number;
};

export type LatLon = {
  lat: number;
  lon: number;
};
